/**
 * @author        matt@zumper.com (Matthieu Devlin)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   nzr specific traktor middleware
 */

import type { PayloadAction } from '@reduxjs/toolkit'
import { getUser } from '@zcode-ui/web-zumper-global-state'
import { LOCATION_CHANGE } from '@zcode-ui/web-zumper-integrations'
import { trackEvent } from '@zcode/integrations'
import { getGclidFromLocalStorage } from '@zcode/legacy-local-storage'
import { localStorageSingleton } from '@zcode/nr-utils'
import type { State } from '@zcode/state-type'
import { getCurrentLocation } from '../../../inspectors/index'
import { DONE_LOADING } from '../../currentSearch/modules/location/constants'
import { selectFilters } from '../../filters/selectors/index'

const trackLocationChange = (action: PayloadAction<unknown>, state: State) => {
  const user = getUser(state)
  const filters = selectFilters(state)
  const location = getCurrentLocation(state)
  return trackEvent(LOCATION_CHANGE, undefined, user, filters, location, {
    getGclidFromLocalStorage,
    localStorageSingleton,
  })
}

export const nzrOnlyTraktorMiddleware = {
  [DONE_LOADING]: trackLocationChange,
}
